import * as React from 'react'

export function useCordova (): typeof window.cordova | undefined {
  const [cordova, setCordova] = React.useState(window.cordova)

  React.useEffect(() => {
    if (cordova) return undefined

    const handler = () => setCordova(window.cordova)
    window.addEventListener('deviceready', handler, false)
    return () => window.removeEventListener('deviceready', handler, false)
  }, [cordova])

  return cordova
}
